export function initializeFirebase() {
  // For mobile app implementation see `crashlytics.native.ts`
}

export async function crashlyticsSetAttribute(name: string, value: string) {
  // For mobile app implementation see `crashlytics.native.ts`
}

export function crashlyticsLog(message: string) {
  // For mobile app implementation see `crashlytics.native.ts`
}
